import AsyncStorage from '@react-native-async-storage/async-storage';
import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware'

export const useWindowStore = create(
  persist(
    (set, get) => ({
        isMobile: false,
        isMobileOrTablet: false,
        isTablet: false,
        isDesktop: true,
        isNative: false,
        group: 'xxl',
        dimensions: { width: 1920, height: 1080 },
        
        setDevice: (device) => set((state) => ({...state, ...device})),
        setGroup: (group) => set((state) => ({...state, group})),
        setWindowData: (data) => set((state) => ({...state, ...data})),

        getDevice: () => {
            const { isMobile, isMobileOrTablet, isTablet, isDesktop, isNative } = get();
            return { isMobile, isMobileOrTablet, isTablet, isDesktop, isNative };
        },

    }),
    {
      name: 'window-storage',
      storage: createJSONStorage(() => AsyncStorage),
    }
  )
);




